import { render } from "./TheHeader.vue?vue&type=template&id=b5b70c12"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
script.render = render

export default script